<template>
  <v-card class="">
    <v-card-title class="text-h5"> {{ param.name }} </v-card-title>

    <v-card-subtitle>{{ param.description }}</v-card-subtitle>

    <v-card-text>
      <v-row class="d-flex flex-no-wrap justify-space-between">
        <v-col cols="8" class="d-flex flex-column flex-grow-1">
          <HelpFormInput
            v-if="param.type === 'string'"
            ref="input"
            v-model="value"
            :label="param.name"
            :placeholder="param.name"
            :help-text="requirements.map((r) => r.description).join(' ')"
            :rules="rules"
            @update:modelValue="onUpdate"
          />
          <HelpFormSwitch
            v-else-if="param.type === 'boolean'"
            ref="input"
            v-model="value"
            :label="param.name"
            :placeholder="param.name"
            :help-text="requirements.map((r) => r.description).join(' ')"
            :rules="rules"
            @update:modelValue="onUpdate"
          />
          <div v-else-if="param.type === 'image'">
            <HelpFileInput
              ref="input"
              v-model="value"
              :label="param.name"
              :placeholder="param.name"
              :help-text="requirements.map((r) => r.description).join(' ')"
              :rules="rules"
              accept="image/png, image/jpeg, image/bmp"
              prepend-icon="mdi-camera"
              @update:modelValue="onUpdate"
            />
          </div>

          <HelpFileInput
            v-else-if="param.type === 'file'"
            ref="input"
            v-model="value"
            :label="param.name"
            :placeholder="param.name"
            :help-text="param.description"
            :rules="rules"
            @update:modelValue="onUpdate"
          />

          <!-- <v-card-actions>
              <v-btn
                class="ms-2"
                size="small"
                text="START RADIO"
                variant="outlined"
              ></v-btn>
            </v-card-actions> -->
        </v-col>

        <v-col
          cols="4"
          class="d-flex flex-column flex-grow-1 flex-shrink-1 align-center justify-center"
        >
          <div
            v-if="param.type === 'image' && value && value.src"
            contain
            class="full-width d-flex justify-center align-center"
          >
            <v-img :src="value.src" contain max-height="125"></v-img>
          </div>
          <span v-if="value && value.ratio" class="pb-2">
            {{ `Ratio: ${value.ratio}, Size: ${value.dimensions}` }}
          </span>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>


<script>
import HelpFileInput from "@/components/atoms/common/inputs/HelpFileInput.vue";
import HelpFormInput from "@/components/atoms/common/inputs/HelpFormInput.vue";
import HelpFormSwitch from "@/components/atoms/common/inputs/HelpFormSwitch.vue";

export default {
  name: "CampaignCreativeParameter",
  components: {
    HelpFormInput,
    HelpFormSwitch,
    HelpFileInput,
  },
  props: {
    modelValue: {
      type: Object,
      default: () => ({}),
    },
    param: {
      type: Object,
      default: () => ({}),
    },
    requirements: {
      type: Array,
      default: () => [],
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["update:modelValue"],

  data() {
    return {
      value: this.param.default || null,
    };
  },
  watch: {
    rules: {
      handler() {
        // next tick
        this.$nextTick(() => {
          if (this.$refs.input && this.value) this.$refs.input.validate();
        });
      },
      immediate: true,
    },
  },
  methods: {
    onUpdate(value) {
      console.log("onUpdate", value);

      switch (this.param.type) {
        case "string": {
          this.value = value;
          console.log("value", this.value);
          this.$emit("update:modelValue", this.value);
          return;
        }
        case "boolean": {
          this.value = value;
          console.log("value", this.value);
          this.$emit("update:modelValue", this.value);
          return;
        }
        case "image": {
          const file = value;

          if (!file) {
            this.value = null;
            this.$emit("update:modelValue", this.value);
            return;
          }

          const img = new Image();
          img.src = URL.createObjectURL(file);
          img.onload = () => {
            const ratioData = this.getClosestRatio(img.width, img.height);
            this.value = {
              file,
              name: file.name,  
              src: img.src,
              size: file.size,
              type: file.type,
              width: img.width,
              height: img.height,
              ratio: ratioData.text,
              w: ratioData.w,
              h: ratioData.h,
              dimensions: `${img.width}x${img.height}`,
            };
            this.$emit("update:modelValue", this.value);
            this.$refs.input.validate();
          };

          return;
        }
        default: {
          this.value = value;
          console.log("value", this.value);
          this.$emit("update:modelValue", this.value);
          return;
        }
      }
    },
    getAspectRatio(width, height) {
      const gcd = (a, b) => {
        return b === 0 ? a : gcd(b, a % b);
      };

      const divisor = gcd(width, height);
      const w = width / divisor;
      const h = height / divisor;

      return {
        text: `${w}:${h}`,
        w: w,
        h: h,
      };
    },
    getClosestRatio(width, height) {
      const ratio = width / height;
      let bestMatch = { w: 1, h: 1 };
      let smallestDiff = Infinity;

      for (let w = 1; w <= 20; w++) {
        for (let h = 1; h <= 20; h++) {
          const currentRatio = w / h;
          const diff = Math.abs(currentRatio - ratio);
          if (diff < smallestDiff) {
            smallestDiff = diff;
            bestMatch = { w, h };
          }
        }
      }

      return {
        text: `${bestMatch.w}:${bestMatch.h}`,
        w: bestMatch.w,
        h: bestMatch.h,
      };
    },
  },
};
</script>